import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';
import { User } from '../../core/model/user.model';

export interface LoginSuccessPayload {
  user: User;
  returnUrl: string;
  viewSessionId: string;
  portalVersion: string;
  isAuthenticatedFromAdmin: boolean;
  returnUrlPathParams: any;
}

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class AuthenticationActions {

    static loginUserFail = createAction('[Auth:Login] Login User Fail');

    static loginUser = createAction('[Auth:Login] Login User', props<{
        username: string,
        password: string,
        rememberMe: boolean,
        returnUrl: string,
        isAuthenticatedFromAdmin: boolean, // TODO: Obsolete as we're getting from backend
        returnUrlPathParams: any,
        accountAccessToken: string
    }>());

    static loginUserSuccess = createAction('[Auth:Login] Login User Success', props<LoginSuccessPayload>());

    static logoutUser = createAction('[Auth:Logout] Logout User');

    static logoutUserSuccess = createAction('[Auth:Logout] Logout User Success');

    static sessionTimeout = createAction('[Auth:Session:Timeout] Session Timeout');

    static websocketSessionTimeout = createAction('[Auth:Session:Timeout] Websocket Session Timeout');

    static failedRequest = createAction('[Auth:Failed:Request] Failed Request', props<{message: string}>());

    static retryFailedRequest = createAction('[Auth:Failed:Request:Retry] Retry Request');

    static cancelFailedRequest = createAction('[Auth:Failed:Request:Cancel] Cancel Retry Request');

    // Once we click true to retry, the stream keeps the value
    static resetFailedRequest = createAction('[Auth:Failed:Request:Reset] Reset Retry Request');

    static windowBeforeUnload = createAction('[Auth:Window:Beforeunload] Browser window closed');

    static getLatestPortalVersion = createAction('[Auth:Portal:Version] Get Latest Portal Version');

    static getLatestPortalVersionSuccess = createAction('[Auth:Portal:Version] Get Latest Portal Version Success'
                , props<{isPortalVersionChanged: boolean}>());
}
